import React from "react";
import buzzed from "../images/buzzed.jpeg";

function CommentPage({ comment, setComment, email, setEmail, onSubmit, isSubmitting }) {
  return (
    <div className="container">
      <div className="card">
        <img src={buzzed} alt="restaurant" className="restaurant-image" />
        <h2 className="title">We'd love to improve</h2>
        <p className="subtitle">Tell us what we can do better</p>

        <textarea
          placeholder="Your feedback..."
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />

        <p className="email-helper">
          Leave your email if you'd like us to follow up.
        </p>

        <input
          type="email"
          placeholder="Your email (optional)"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="email-input"
        />

        <button onClick={onSubmit} className="button button-primary" disabled={isSubmitting}>
          Submit Feedback
        </button>

        <p className="powered">
          Feedback helps us serve you better ❤️
        </p>
      </div>
    </div>
  );
}

export default CommentPage;